import { useAtomValue } from 'jotai';

import {
  ProviderResourcesCollapsibleContainerConnected,
  useGetClientHasTherapyToolkitEnabled,
} from '@grow-therapy-team/seedling-components';

import {
  inSessionPatientInformationAtom,
  providerShortIdAtom,
  selectedClientInfoAtom,
  selectedClientUserShortIdAtom,
} from '../state';
import { useCachedPatientByShortId } from '../useGetPatientByShortId';

export function ProviderResourcesCollapsibleContainerWrapper() {
  const clientUserShortId = useAtomValue(selectedClientUserShortIdAtom) ?? '';
  const providerShortId = useAtomValue(providerShortIdAtom) ?? '';
  const appointmentShortId = useAtomValue(inSessionPatientInformationAtom)?.inSessionAppointmentShortId ?? undefined;
  const { data: clientHasTherapyToolkitEnabledData } = useGetClientHasTherapyToolkitEnabled(clientUserShortId);
  const isTherapyToolkitFeatureEnabled = clientHasTherapyToolkitEnabledData?.clientHasTherapyToolkitEnabled;
  const selectedPatientShortId = useAtomValue(selectedClientInfoAtom)?.patientShortId;
  const { data: cachedPatientData } = useCachedPatientByShortId(selectedPatientShortId);
  const isClientUserMinor = cachedPatientData?.patientChart?.clientUser?.isMinor ?? false;
  const isPatientEnrolledInStructuredCareProgram =
    cachedPatientData?.patientChart?.isEnrolledInStructuredCareProgram ?? false;
  if (!isTherapyToolkitFeatureEnabled) return null;

  return (
    <ProviderResourcesCollapsibleContainerConnected
      clientUserShortId={clientUserShortId}
      providerShortId={providerShortId}
      isHidden={isClientUserMinor}
      isPatientEnrolledInStructuredCareProgram={isPatientEnrolledInStructuredCareProgram}
      appointmentShortId={appointmentShortId}
      isInverse
    />
  );
}
